import { useMemo, useEffect } from 'react';
import { throttle } from 'lodash';

/**
 * Returns a memoized & throttled callback function.
 *
 * https://lodash.com/docs/4.17.15#throttle
 *
 * @param {Function} callback The callback function
 * @param {Number} wait Timeout in milliseconds
 * @param {import('lodash').ThrottleSettings} [options] Additional options for the throttle. Make
 *                                                      sure you memoize the value for this!
 */
export default function useThrottled(callback, wait, options) {
    const throttleFn = useMemo(() => throttle(callback, wait, options), [callback, wait, options]);

    // when unmounting, automatically kill off the throttled function
    useEffect(() => () => throttleFn.cancel(), [throttleFn]);

    return throttleFn;
}
